// Mock data for White Orchid Homestay

export const homestayInfo = {
  name: "White Orchid Homestay",
  tagline: "Your Home in the Hills",
  address: "Chaitaypani Busty, Baghgora Road, Chimney-Deorali village, near Dowhill School, Kurseong, District Darjeeling, West Bengal, India, PIN 734220",
  phone: "+91-9091265065",
  whatsapp: "+91-9091265065",
  email: "whiteorchid734203@gmail.com",
  established: "2022",
  rating: "4.8",
  reviewCount: "200",
  social: {
    instagram: "white_orchid_homestay",
    facebook: "White Orchid Homestay"
  },
  googleMapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14256.047573486938!2d88.2732!3d26.8754!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e44e0b5e1d5e1d%3A0x1d5e1d5e1d5e1d5e!2sKurseong%2C%20West%20Bengal!5e0!3m2!1sen!2sin!4v1234567890"
};

export const rooms = [
  {
    id: 1,
    name: "Room No-1",
    capacity: 2,
    beds: "1 double bed",
    bathroom: "Attached bathroom",
    view: "Limited pine forest view",
    amenities: ["Western commode", "Hot water geyser", "Free WiFi"],
    size: "11 x 13 ft",
    tariff: {
      withFood: 1300,
      lodgingOnly: 1500
    },
    images: [
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/qndveym1_IMG-20251123-WA0027.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/1l19wn3z_IMG-20251123-WA0041.jpg"
    ]
  },
  {
    id: 2,
    name: "Room No-2",
    capacity: 4,
    beds: "2 double beds",
    bathroom: "Detached but dedicated bathroom (just outside room)",
    view: "Spectacular Mt. Kanchenjunga + pine forest view",
    amenities: ["Western commode", "Hot water geyser", "Free WiFi"],
    size: "11 x 13 ft",
    tariff: {
      withFood: 1300,
      lodgingOnly: 1900
    },
    images: [
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/sy4e3u8f_IMG-20251123-WA0025.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/y6ygni0r_IMG-20251123-WA0037.jpg"
    ],
    featured: true
  },
  {
    id: 3,
    name: "Room No-3",
    capacity: 2,
    beds: "1 double bed",
    bathroom: "Detached but dedicated bathroom (just outside room)",
    view: "Spectacular Mt. Kanchenjunga view",
    amenities: ["Western commode", "Hot water geyser", "Free WiFi"],
    size: "11 x 13 ft",
    tariff: {
      withFood: 1300,
      lodgingOnly: 1500
    },
    images: [
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/zakjz4z0_IMG-20251123-WA0032.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/qt5ytwwh_IMG-20251217-WA0032.jpg"
    ],
    featured: true
  },
  {
    id: 4,
    name: "Room No-4",
    capacity: 4,
    beds: "2 double beds",
    bathroom: "Attached bathroom",
    view: "No view",
    amenities: ["Western commode", "Hot water geyser", "Free WiFi"],
    size: "11 x 13 ft",
    tariff: {
      withFood: 1300,
      lodgingOnly: 1900
    },
    images: [
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/5gl9884s_IMG-20251123-WA0026.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/dun1kmxn_IMG-20251123-WA0029.jpg"
    ]
  }
];

export const experiences = [
  {
    id: 1,
    title: "Complimentary Guided Nature Hikes",
    description: "Explore the serene Dowhill pine forest with our experienced guides. Discover hidden trails, breathe in the fresh mountain air, and connect with nature.",
    icon: "Footprints",
    complimentary: true,
    images: [
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/7oxc78sv_IMG_4286.JPG"
    ]
  },
  {
    id: 2,
    title: "Complimentary Cycling Tours",
    description: "Pedal through the picturesque Dowhill pine forest on our complimentary cycling tours. Perfect for adventure enthusiasts and nature lovers alike.",
    icon: "Bike",
    complimentary: true,
    images: [
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/sfr6xlim_IMG-20240924-WA0013%5B1%5D.JPG",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/nfma5f77_IMG_E0736.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/ewe8x3nt_Screenshot%202025-04-03%20215818.png"
    ],
    showMultiple: true
  },
  {
    id: 3,
    title: "Bonfire Evenings",
    description: "Gather around a cozy bonfire under the starlit sky. Share stories, make memories, and enjoy the warmth of our hospitality.",
    icon: "Flame",
    complimentary: false,
    images: [
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/h6eta7pa_IMG_3284.JPG",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/z8072ipd_13fe2d3b-2e66-48f7-bcb6-af6c47a1abab.webp"
    ],
    showMultiple: true
  },
  {
    id: 4,
    title: "BBQ Experience",
    description: "Savor delicious grilled delicacies in the fresh mountain air. Our BBQ setup is perfect for special evenings with family and friends.",
    icon: "UtensilsCrossed",
    complimentary: false,
    images: [
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/4zqs7g4k_IMG_1710.jpg"
    ]
  }
];

export const usps = [
  {
    icon: "Mountain",
    title: "Spectacular Mt. Kanchenjunga Views",
    description: "Wake up to breathtaking views of the world's third-highest peak from select rooms."
  },
  {
    icon: "Trees",
    title: "Surrounded by Pine Forest",
    description: "Immerse yourself in the tranquility of lush Dowhill pine forest, right at our doorstep."
  },
  {
    icon: "UtensilsCrossed",
    title: "Fresh Home-Cooked Food",
    description: "Savor authentic, hygienic home-cooked meals prepared with love and fresh ingredients."
  },
  {
    icon: "Heart",
    title: "Personalized Hospitality",
    description: "Experience warm, personalized service that makes you feel right at home."
  },
  {
    icon: "MapPin",
    title: "Easy Road Access",
    description: "Located directly on the main road - no walking or climbing required. Ideal for elderly guests."
  },
  {
    icon: "Car",
    title: "Enclosed Parking Space",
    description: "Secure parking for up to 6 cars within our property premises."
  }
];

export const facilities = [
  "Total 4 spacious rooms (11 x 13 ft each)",
  "Accommodates up to 12 guests",
  "All bathrooms with western commode and hot water geyser",
  "Large outdoor spaces (front, back, terrace)",
  "Enclosed parking for 6 cars",
  "Outdoor sitting & dining area",
  "Bonfire and BBQ on request",
  "Free high-speed WiFi"
];

export const tariffOptions = [
  {
    id: 1,
    name: "Food + Lodging Package",
    price: "₹1,300 per person per night",
    includes: [
      "Breakfast",
      "Lunch",
      "Evening snacks with tea",
      "Dinner",
      "Comfortable accommodation",
      "All basic amenities"
    ],
    recommended: true
  },
  {
    id: 2,
    name: "Lodging Only",
    rooms: [
      {
        name: "Room 1 & 3",
        price: "₹1,500 per room per night"
      },
      {
        name: "Room 2 & 4",
        price: "₹1,900 per room per night"
      }
    ],
    note: "Meals can be arranged separately on request"
  }
];

export const reviews = [
  {
    id: 1,
    author: "Suraj Sarkar",
    rating: 5,
    text: "Our stay at this homestay was simply amazing. The hosts treated us like their own family, the rooms were spotless, and the food was freshly prepared every day. The view from the balcony was breathtaking. A perfect place for anyone looking for peace and comfort! Highly recommended",
    date: "27 weeks ago"
  },
  {
    id: 2,
    author: "Souvo Chowdhury",
    rating: 5,
    text: "Went there with our school friends... it is one of the few properties in Kurseong from where you get clear view of Kanchenzonga. Loved Phincho's (owner) approach, to the point and clarifying before what is included and what is not. Rooms were clean with all the basic facilities. Dipen and his partner is a champ, always serving with a smile. Ideal place for a group stay.",
    date: "16 weeks ago"
  },
  {
    id: 3,
    author: "Arindham Bandyopadhyay",
    rating: 5,
    text: "It's been a very pleasant experience at White Orchid Homestay. The entire staff was very customer friendly and polite in every interaction. The wifi was working really well. The parking at the property is also a plus for people wanting to self drive. Food served was tasty and they kept every request we made. I will recommend this homestay anytime to people wanting to explore Dowhill.",
    date: "16 weeks ago"
  },
  {
    id: 4,
    author: "Somenath Datta",
    rating: 5,
    text: "It's located in a unique place where you get see the beautiful Pine forest and a clear view of the incredible Kanchenjunga. The rooms were spotless and comfortable. They treated us like family. Every meals provided were mouthwatering and served hot. They provide a guided hike through the Pine forest which was a one of a kind experience.",
    date: "16 weeks ago"
  }
];

export const galleryCategories = [
  {
    id: "rooms",
    name: "Rooms & Bathrooms",
    images: [
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/qndveym1_IMG-20251123-WA0027.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/1l19wn3z_IMG-20251123-WA0041.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/sy4e3u8f_IMG-20251123-WA0025.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/y6ygni0r_IMG-20251123-WA0037.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/zakjz4z0_IMG-20251123-WA0032.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/5gl9884s_IMG-20251123-WA0026.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/dun1kmxn_IMG-20251123-WA0029.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/qh9wjdr6_IMG-20251217-WA0031.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/qt5ytwwh_IMG-20251217-WA0032.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/m7k7goed_IMG-20251217-WA0033.jpg"
    ]
  },
  {
    id: "views",
    name: "Mt. Kanchenjunga Views",
    images: [
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/959bsctm_IMG_20241022_071333.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/8eks4ne8_IMG_20250109_081852.jpg"
    ]
  },
  {
    id: "surroundings",
    name: "Pine Forest & Surroundings",
    images: [
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/dg45e8qb_IMG-20251217-WA0020.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/cym1jsk7_IMG-20250425-WA0023.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/p5tsukpn_PHOTO-2024-01-22-18-05-59%20%281%29.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/a0g7zs7e_IMG_20241103_183338.jpg"
    ]
  },
  {
    id: "outdoor",
    name: "Outdoor Spaces & Night Views",
    images: [
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/h6eta7pa_IMG_3284.JPG",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/z8072ipd_13fe2d3b-2e66-48f7-bcb6-af6c47a1abab.webp",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/kzvb4hlc_IMG_3614.JPG",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/p5tsukpn_PHOTO-2024-01-22-18-05-59%20%281%29.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/a0g7zs7e_IMG_20241103_183338.jpg"
    ]
  },
  {
    id: "food",
    name: "Food & Dining",
    images: [
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/xtymiwc4_Gemini_Generated_Image_mxgreqmxgreqmxgr.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/tshszgzf_IMG_1378.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/4zqs7g4k_IMG_1710.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/0y2nt9te_BOWC3352.JPG"
    ]
  },
  {
    id: "property",
    name: "Property Exterior",
    images: [
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/vo4xtug2_DPQD9327.JPG",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/7r9lv9ms_IMG-20251217-WA0028.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/cym1jsk7_IMG-20250425-WA0023.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/kzvb4hlc_IMG_3614.JPG",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/dg45e8qb_IMG-20251217-WA0020.jpg"
    ]
  },
  {
    id: "attractions",
    name: "Nearby Attractions - Explore Kurseong",
    images: [
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/dwm1l1ro_gallery-image-.08.58%20AM.jpeg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/f75iyvcu_Dow-Hill-School-Kurseong.jpeg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/uaxyxxcg_imresizer-1712250571435.jpg",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/c35hckc8_RWDV1908.JPG",
      "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/78n42vbq_Screenshot%202024-02-13%20183009.png"
    ]
  }
];

export const heroImages = [
  "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/vo4xtug2_DPQD9327.JPG",
  "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/cym1jsk7_IMG-20250425-WA0023.jpg",
  "https://customer-assets.emergentagent.com/job_peaceful-orchid/artifacts/8eks4ne8_IMG_20250109_081852.jpg"
];
